import { useOAIQuery } from '~/hooks/reactQuery';

export const useTopPvProducts = (categoryId?: string) => {
  const { data, ...props } = useOAIQuery({
    queryKey: '/api/market-place/v1/top-pv/products',
    variables: {
      hour: new Date().getHours(),
      ...(categoryId &&
        !!Number(categoryId) && { categoryId: Number(categoryId) }),
    },
    queryOptions: {
      keepPreviousData: true,
    },
  });

  return {
    data,
    ...props,
  };
};
